module.exports = __webpack_public_path__ + "media/images/fanclub/merit-chara-01-8df50cc5732070abbeb1a49bcab4973f.png";